export default "__VITE_ASSET__vbCg7PTc__"